module.exports = __webpack_public_path__ + "img/overview_brand_01.3b3cce8a.jpg";